import { useSessionPermission } from '@btime/react-session'
import React from 'react'
import TextCopy from './TextCopy'

const RecordReference = ({ record, labelPrefix, valuePrefix, ...props }) => {
  const canSeeId = useSessionPermission('seeRecordIds')
  if (!canSeeId) return false

  return (
    <>
      <TextCopy
        label={`${labelPrefix || 'REF'}: ${record?.reference}`}
        value={`${valuePrefix || ''}${record?.reference}`}
        size="xxxsmall"
        iconSize={0.6}
        color="dark5"
        {...props}
      />
    </>
  )
}

export default RecordReference
